// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slider_wrapper__31y7m","icon":"slider_icon__2bKQ-","selectedItem":"slider_selectedItem__LupcI","container":"slider_container__Wa_E-","shelf":"slider_shelf__8LFl7"};